module.exports = __webpack_public_path__ + "img/frame (244).ed6bdc62.jpg";